import(/* webpackMode: "eager" */ "/home/ubuntu/download_production/6a869fe5bedae7001454d495_1787304957489_c1524db4/betaland/src/app/partner/mobile/lead/page.tsx");
